import {
  AlertTriggerTiming,
  AlertTriggerTypeEnum,
  EtlBookingTypeEnum,
  ReportPeriodGroupingEnum,
} from "../enums";
import { ISelectListItem, TJsonTypeOption } from "../models";

export const DIRECTIONS_RIDE: ISelectListItem[] = [
  { value: "A", label: "A" },
  { value: "B", label: "B" },
];

export const jsonTypes: TJsonTypeOption[] = [
  "string",
  "number",
  "boolean",
  "array",
  "object",
  "date",
];
export const jsonTypeOptions = jsonTypes.map(p => ({ value: p, label: p }));

export const dbStructureSelectOptions = [
  {
    value: "black",
    label: "Black",
  },
  {
    value: "blue",
    label: "Blue",
  },
  {
    value: "purple",
    label: "Purple",
  },
];

/** A or B only - for flows that act on one direction at a time and never on both. */
export const DIRECTIONS_A_B: ISelectListItem[] = [
  { value: "A", label: "selectListLabel.DirectionA" },
  { value: "B", label: "selectListLabel.DirectionB" },
];

export const DIRECTIONS_INCLUDE_BOTH: ISelectListItem[] = [
  ...DIRECTIONS_A_B,
  { value: "AB", label: "selectListLabel.DirectionAB" },
];

export const DIRECTIONS_CREATE_RIDE: ISelectListItem[] = [
  { value: "A", label: "selectListLabel.DirA" },
  { value: "B", label: "selectListLabel.DirB" },
];

export const periodGroupingItems: ISelectListItem[] = [
  {
    value: ReportPeriodGroupingEnum.EntirePeriod,
    label: "selectListLabel.EntirePeriod",
  },
  { value: ReportPeriodGroupingEnum.Weekly, label: "selectListLabel.Weekly" },
  { value: ReportPeriodGroupingEnum.Monthly, label: "selectListLabel.Monthly" },
  { value: ReportPeriodGroupingEnum.Daily, label: "selectListLabel.Daily" },
];

export const timeZoneList =
  Intl.supportedValuesOf("timeZone")?.map(item => ({
    value: item,
    label: item,
  })) ?? [];

export const CUSTOM_PRODUCTION_RIDE_TYPES: ISelectListItem[] = [
  { value: "Shuttle", label: "selectListLabel.shuttle" },
  { value: "FlexCourse", label: "selectListLabel.flexCourse" },
  { value: "Geo", label: "selectListLabel.geoProduction" },
  { value: "Hub", label: "selectListLabel.hub" },
];

export const CUSTOM_PRODUCTION_PRODUCE_JOIN_TYPES = [
  { value: "produce", label: "selectListLabel.produce" },
  { value: "join", label: "selectListLabel.join" },
  { value: "both", label: "selectListLabel.produceAndJoin" },
];

export const selectListBookingsTypes: ISelectListItem[] = [
  EtlBookingTypeEnum.flight,
  EtlBookingTypeEnum.sightseeing,
  EtlBookingTypeEnum.game,
  EtlBookingTypeEnum.training,
].map(item => ({
  value: item,
  label: item,
}));

export const selectListAlertConfigurationTriggerType: ISelectListItem[] = [
  { value: AlertTriggerTypeEnum.SCHEDULED, label: "selectListLabel.scheduled" },
];

export const selectListAlertConfigurationTriggerTiming: ISelectListItem[] = [
  { value: AlertTriggerTiming.BEFORE, label: "selectListLabel.before" },
  { value: AlertTriggerTiming.AFTER, label: "selectListLabel.after" },
  { value: AlertTriggerTiming.RECURRING, label: "selectListLabel.recurring" },
];
